import xhrCaller from "./xhr-caller";

export const xhrWadoGetToken = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'wado', action: 'studies/medtoken', method: 'post', data, json: false});	
	return result;
};

export const xhrWadoGetSeries = async (token, studyUID) => {
	var result = await xhrCaller({ bearer: token, srv: 'wado', action: 'studies/' + studyUID + '/seriesUIDs'});	
	return { studyUID : studyUID , result: result?.result };
};

export const xhrWadoGetInstances = async (token, studyUID, seriesUID) => {
	var result = await xhrCaller({ bearer: token, srv: 'wado', action: 'studies/' + studyUID + '/series/' + seriesUID + '/instanceUIDs'});	
	return result?.result;
};

export const xhrWadoDisableInstances = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'wado', action: 'studies/DisableInstances', method: 'post', data : data});	
	return result?.result;
};
